import { cn } from '@scalis/utils'

export const iconButtonClassName = cn(
  'text-icon-neutral-20 inline-flex cursor-pointer items-center justify-center w-6 h-6',
  'rounded border-0 bg-transparent focus:outline-none disabled:cursor-not-allowed',
  'hover:bg-button-subtle-hover',
  'active:bg-button-subtle-pressed',
  'disabled:text-icon-neutral-00',
)
